export default __webpack_public_path__ + "static/media/GA_Portre_sm.90e665bd.jpg";